import React from 'react';
import { AlertCircle, ExternalLink } from 'lucide-react';
import { useSystemHealth } from '../hooks/useSystemHealth';

/**
 * System-wide banner that shows when database or critical services are unavailable
 * Appears at the top of the app to warn users about degraded functionality
 */
export function SystemStatusBanner() {
  const health = useSystemHealth();

  // Temporarily disabled - health check needs server restart to apply fix
  // TODO: Re-enable after server restart
  return null;

  // Only show banner when database is unavailable
  if (health.databaseAvailable) {
    return null;
  }

  return (
    <div className="w-full bg-gradient-to-r from-red-500 to-red-600 text-white px-6 py-3 shadow-lg z-50">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <AlertCircle className="w-5 h-5 flex-shrink-0" />
          <div>
            <p className="font-semibold text-sm">
              Database Connection Issue
            </p>
            <p className="text-xs text-red-100 mt-0.5">
              {health.databaseError || 'Unable to connect to database. Some features may be unavailable.'}
            </p>
          </div>
        </div>
        <div className="flex items-center space-x-4">
          <a
            href="https://status.supabase.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center space-x-1 text-xs hover:underline"
          >
            <span>Check Supabase Status</span>
            <ExternalLink className="w-3 h-3" />
          </a>
          <span className="text-xs text-red-100">
            Last checked: {health.lastChecked.toLocaleTimeString()}
          </span>
        </div>
      </div>
    </div>
  );
}
